module.exports = __webpack_public_path__ + "static/media/objects_13.e86e66c5.svg";